import React from 'react'
import {
  ButtonDropdown,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Spinner,
} from "reactstrap";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import oikosApi from "../../services/oikos";
import { useSelector } from "react-redux";
import qs from "qs";
import moment from "moment";
import { selectValues } from "../../utils/fc";
import { notifyError, notifySuccess } from '../../utils/notify';
import {
  CONTR_FORN_STATUS_EM_APROVACAO,
  CONTR_FORN_STATUS_EM_ASSINATURA,
  needsContrFornApproval,
} from '../../components/Modals/ModalFormContrForn/contrFornApprovalRules';
import { persistPgtoPrazoDias } from '../../components/Modals/ModalFormContrForn/contrFornEntregaveisUtils';
import ModalPedidoCompra, { fetchPedidoCompraDocuments } from '../../components/Modals/ModalPedidoCompra/ModalPedidoCompra';
import ModalPedidoCotacao, {
  TIPO_CONTRATACAO,
  TIPO_CONTRATACAO_LABEL,
} from '../../components/Modals/ModalPedidoCotacao/ModalPedidoCotacao';
import PedidosCompraListTable from '../../components/Template/Doc/PedidosCompraListTable';
import {
  PEDIDO_COMPRA_STATUS_APROVADO,
  PEDIDO_COMPRA_STATUS_CONTRATADO,
} from '../../components/Template/Doc/compraCotacaoTableUtils';

function CotacoesTab(props) {
  const onlyPedidoCotacao = Boolean(props.onlyPedidoCotacao);
  const [pedidosDeCompra, setPedidosDeCompra] = React.useState([]);
  const [cotacaoStatusTab, setCotacaoStatusTab] = React.useState(0);
  const [abrirCotacaoDropdownOpen, setAbrirCotacaoDropdownOpen] = React.useState(false);
  const [tipoContratacaoModal, setTipoContratacaoModal] = React.useState(TIPO_CONTRATACAO.PADRAO);
  const [isModalProdutosOpen, setIsModalProdutosOpen] = React.useState(false);
  const [localIsModalOpen, setLocalIsModalOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [isLoadingPedidosCompra, setIsLoadingPedidosCompra] = React.useState(false);
  const [selOrcItems, setSelOrcItems] = React.useState([]);
  const [listaDotacoes, setListaDotacoes] = React.useState([]);
  const [listaParcelas, setListaParcelas] = React.useState([]);
  const [selCentroDeCusto, setSelCentroDeCusto] = React.useState([]);
  const [selTiposDeMinuta, setSelTiposDeMinuta] = React.useState([]);
  const [editPedidoCompraRow, setEditPedidoCompraRow] = React.useState(null);
  const [cotacaoPedidoExistenteRow, setCotacaoPedidoExistenteRow] = React.useState(null);
  const [compraCotacoesRefreshKey, setCompraCotacoesRefreshKey] = React.useState(0);
  const [contrFornData, setContrFornData] = React.useState({});
  const [viewPedidoCompraModalIsOpen, setViewPedidoCompraModalIsOpen] = React.useState(false);
  const [viewPedidoCompraRow, setViewPedidoCompraRow] = React.useState(null);
  const [viewCompraCotacaoModalIsOpen, setViewCompraCotacaoModalIsOpen] = React.useState(false);
  const [viewCompraCotacaoRow, setViewCompraCotacaoRow] = React.useState(null);
  const { user } = useSelector(state => state.auth);
  const [selFornecedores, setSelFornecedores] = React.useState({});
  const [filesContrForn, setFilesContrForn] = React.useState([]);
  const [selPjs, setSelPjs] = React.useState([]);
  const [selPfs, setSelPfs] = React.useState([]);
  const [selPfsFornecedor, setSelPfsFornecedor] = React.useState([]);
  const [selPjsFornecedor, setSelPjsFornecedor] = React.useState([]);
  const [selStatus, setSelStatus] = React.useState([]);
  const [selTipoContrato, setSelTipoContrato] = React.useState([]);
  const [selPropItems, setSelPropItems] = React.useState([]);
  const [pageContrFornForm, setPageContrFornForm] = React.useState(1);
  const [valoresLimites, setValoresLimites] = React.useState([]);
  const isPedidoCompraModalOpen = props.isModalOpen ?? localIsModalOpen;
  const setPedidoCompraModalOpen = props.setIsModalOpen ?? setLocalIsModalOpen;
  //const [contrFornEventos, setContrFornEventos] = React.useState([]);
  //const [bdros, setBdros] = React.useState([]);

  const filteredDotacoes = React.useMemo(() => {
    const { contrForn_dtVigIni, contrForn_dtVigFim } = contrFornData;
    if (!contrForn_dtVigIni || !contrForn_dtVigFim) return [];
    const [sY, sM] = contrForn_dtVigIni.split("-").map(Number);
    const [eY, eM] = contrForn_dtVigFim.split("-").map(Number);
    const startYM = sY * 100 + sM;
    const endYM   = eY * 100 + eM;
    if (startYM > endYM) return [];
    return listaDotacoes.filter(({ orcDot_data }) => {
      const [y, m] = orcDot_data.split("-").map(Number);
      const itemYM = y * 100 + m;
      return itemYM >= startYM && itemYM <= endYM;
    });
  }, [
    contrFornData.contrForn_dtVigIni,
    contrFornData.contrForn_dtVigFim,
    listaDotacoes
  ]);

  const filteredValoresLimites = React.useMemo(() => {
    const { contrForn_dtVigIni, contrForn_dtVigFim } = contrFornData;
    if (!contrForn_dtVigIni || !contrForn_dtVigFim) return [];
    const [sY, sM] = contrForn_dtVigIni.split("-").map(Number);
    const [eY, eM] = contrForn_dtVigFim.split("-").map(Number);
    const startYM = sY * 100 + sM;
    const endYM   = eY * 100 + eM;
    if (startYM > endYM) return [];
    return valoresLimites.filter(({ mes }) => {
      const [y, m] = mes.split("-").map(Number);
      const itemYM = y * 100 + m;
      return itemYM >= startYM && itemYM <= endYM;
    });
  }, [
    contrFornData.contrForn_dtVigIni,
    contrFornData.contrForn_dtVigFim,
    valoresLimites
  ]);

  /*
  const filteredBdros = React.useMemo(() => {
    const { contrForn_dtVigIni, contrForn_dtVigFim } = contrFornData;
    console.log('contrFornData', contrFornData);
    if (!contrForn_dtVigIni || !contrForn_dtVigFim) return [];
    const [sY, sM] = contrForn_dtVigIni.split("-").map(Number);
    const [eY, eM] = contrForn_dtVigFim.split("-").map(Number);
    const startYM = sY * 100 + sM;
    const endYM   = eY * 100 + eM;
    if (startYM > endYM) return [];
    const filtered = bdros.filter(({ bdro_dtVenc, bdro_tabRef, bdro_tabId }) => {
      if (!bdro_dtVenc) {
        notifyError('Algum bordero não possui data de vencimento.');
        return false;
      }
      if (!bdro_tabRef && !bdro_tabId) {
        const [y, m] = bdro_dtVenc.split("-").map(Number);
        const itemYM = y * 100 + m;
        return itemYM >= startYM && itemYM <= endYM;
      }
    });
    console.log('filtered', filtered);
    return filtered;
  }, [
    contrFornData.contrForn_dtVigIni,
    contrFornData.contrForn_dtVigFim,
    contrFornEventos
  ]);

  const valorLimite = React.useMemo(() => {
    let somaDotacoes = 0;
    if (filteredDotacoes.length) {
      somaDotacoes = filteredDotacoes
        .reduce((acc, { orcDot_valor }) => acc + Number(orcDot_valor || 0), 0);
    }
    console.log('somaDotacoes', somaDotacoes);
    let somaJaAlocadoEventos = 0;
    if (filteredEventos.length) {
      somaJaAlocadoEventos = filteredEventos
        .reduce((acc, { contrFornEvento_vlr }) => acc + Number(contrFornEvento_vlr || 0), 0);
    }
    console.log('somaJaAlocadoEventos', somaJaAlocadoEventos);
    let somaJaAlocadoBdros = 0;
    if (filteredBdros.length) {
      somaJaAlocadoBdros = filteredBdros
        .reduce((acc, { bdro_vlr }) => {
          return acc + Number(bdro_vlr || 0)
        }, 0);
    }
    console.log('somaJaAlocadoBdros', somaJaAlocadoBdros);
    return Number((somaDotacoes - somaJaAlocadoEventos - somaJaAlocadoBdros).toFixed(2));
  }, [filteredDotacoes, filteredEventos, filteredBdros]);
  */


  const handleCloseModal = () => {
    setPedidoCompraModalOpen(false)
    setEditPedidoCompraRow(null)
    setCotacaoPedidoExistenteRow(null)
  }

  const handleOpenProdutosModal = () => setIsModalProdutosOpen(true);
  const handleCloseModalProdutos = () => {setIsModalProdutosOpen(false); setPageContrFornForm(1)};

  async function saveDocuments(files, contrFornRecord) {
    // Cria um registro na tabela de documentos para cada arquivo
    await Promise.all(files.map(async (file) => {
      const documentBody = {
        action: 'insert',
        table: 'documento',
        data: {
          tpDocumento_id: file.props.documentType.tpDocumento_id,
          documento_desc: `Contrato ${file.data.path}`,
          documento_iniVig: undefined,
          documento_fimVig: undefined,
          documento_dtEmissao: undefined,
          documento_prazo: undefined,
          documento_ref: undefined,
          privacidade_id: 2,
        },
      }
      const documentCreated = await oikosApi.post('/', documentBody)

      // Cria uma vinculação entre o documento (anexo) e o registro da minuta
      if (documentCreated.data[0].documento_id) {
        const vinculationBody = {
          action: 'insert',
          table: 'documentoVinc',
          data: {
            documento_id: documentCreated.data[0].documento_id,
            documentoVinc_tabRef: 'contrForn',
            documentoVinc_tabId: contrFornRecord.contrForn_id,
          },
        }
        await oikosApi.post('/', vinculationBody)
      }

      // Faz upload do arquivo e registra na tabela 'arquivo'
      const formData = new FormData()
      formData.append('file', new Blob([file.data], { type: file.data.type }), file.data.path)
      formData.append('table', 'arquivo')
      formData.append('action', 'upload_file')
      formData.append('arquivo_tabRef', 'documento')
      formData.append('arquivo_tabId', documentCreated.data[0].documento_id)
      formData.append('arquivo_privacidade', documentCreated.data[0].privacidade_id)
      formData.append('arquivo_desc', file.data.path)
      const fileUploadRes = await oikosApi.post('/', formData)
      console.tron.log('fileUploadRes', fileUploadRes)
    }))
  }

  function verificarSaldoMensalValido(listaValoresLimites, listaParcelas) {
    for (const valorLimite of listaValoresLimites) {
      const monthRef = valorLimite.mes.slice(0, 7); // 'YYYY-MM'

      // Soma todas as parcelas do mesmo mês
      const somaParcelasMes = listaParcelas
        .filter(parcela => parcela.contrFornEvento_dtPrev ? parcela.contrFornEvento_dtPrev.slice(0, 7) === monthRef : false)
        .reduce((acc, cur) => acc + Number(cur.contrFornEvento_vlr || 0), 0);

      // Compara
      const diferenca = Number(Number(valorLimite.disponivel).toFixed(2)) - Number(somaParcelasMes.toFixed(2));

      if (diferenca < 0) {
        return false;
      }
    }

    return true;
  }

  const comparaValorGlobalComParcelas = () => {
    const somaParcelas = listaParcelas.reduce((acc, parcela) => {
      return acc + (parcela.contrFornEvento_vlr || 0);
    }, 0);

    if (Number(Number(somaParcelas).toFixed(2)) > Number(Number(contrFornData.contrForn_vlrGlobal).toFixed(2))) {
      notifyError('A soma das parcelas não pode ser maior que o valor global do contrato.');
      return false;
    }
    if (Number(Number(somaParcelas).toFixed(2)) !== Number(Number(contrFornData.contrForn_vlrGlobal).toFixed(2))) {
      notifyError('A soma das parcelas deve ser igual ao valor global do contrato.');
      return false;
    }
    return true;
  }

  function verificarValorGlobal() {
    const somaValoresLimites = valoresLimites.reduce((acc,cur)=>{
      return Number(acc) + Number(cur.disponivel)
    }, 0)
    if (Number(Number(contrFornData.contrForn_vlrGlobal).toFixed(2)) > somaValoresLimites) {
      notifyError('Saldo insuficiente')
      return false;
    }
    return true;
  }

  function handleAddParcela() {
    setListaParcelas(prev => [...prev, {contrFornEvento_vlr: 0, contrFornEvento_dtPrev: null, contrFornEvento_num: prev.length + 1, contrFornEvento_desc: `Parcela ${prev.length + 1}`}]);
  }

  function handleDeleteParcela(contrFornEvento_num) {
    setListaParcelas((prev) => prev
    .filter((t) => t.contrFornEvento_num !== contrFornEvento_num)
    .map((p, i) => {
      const parcelaPattern = /^Parcela \d+$/; // matches "Parcela 1", "Parcela 2"...
      return {
        ...p,
        contrFornEvento_num: i + 1,
        contrFornEvento_desc: parcelaPattern.test(p.contrFornEvento_desc)
          ? `Parcela ${i + 1}`
          : p.contrFornEvento_desc,
      };
    }));
  }

  function verificaDocumentoContrForn() {
    console.log(contrFornData.contrFornStatus_id)
    if(filesContrForn.length <= 0) {
      notifyError('Campo de "Anexos complementares" vazio')
      return false;
    }
    if (filesContrForn.length > 0) {
      const filesSemTipo = filesContrForn.filter(file => !file.props.documentType);
      if (filesSemTipo.length > 0) {
        notifyError("Algum documento está sem Tipo");
        return false;
      }
    }
    return true;
  }

  function verificaDataVigencia() {
    if(new Date(contrFornData.contrForn_dtVigFim) < new Date(contrFornData.contrForn_dtVigIni)) {
      notifyError('Data de início da vigência é maior que data de fim.')
      return false;
    }

    const parcelasForaDoIntervaloDeVigencia = listaParcelas.filter(p => new Date(p.contrFornEvento_dtPrev) > new Date(contrFornData.contrForn_dtVigFim) || new Date(p.contrFornEvento_dtPrev) < new Date(contrFornData.contrForn_dtVigIni));
    if(parcelasForaDoIntervaloDeVigencia.length > 0) {
      notifyError('Alguma parcela está com Data Prevista fora do intervalo de vigência do contrato.')
      return false;
    }

    return true;
  }

  const fetchPedidosDeCompra = async () => {
    if (!user) return;
    try {
      setIsLoadingPedidosCompra(true);
      const data = {
        pedidoCompra_ativo: 1,
        ...(user.perm_id === 1 ? {} : { pf_id: user.pf_id }),
        ...(onlyPedidoCotacao ? { pedidoCompra_pedidoCotacao: 1 } : {}),
      };

      // Mesmo critério das abas de contratos: itens da árvore orçamentária do projeto.
      if (props.proj_orcRubrId) {
        data.orcItem_id = `!IN!(SELECT orcItem_id FROM orcItem WHERE orcRubr_id IN (SELECT id_oikos FROM viewOrcRubr_taxonomia2 WHERE nivel3_id = ${props.proj_orcRubrId}))`;
      }

      const query = qs.stringify({
        action: 'get',
        table: 'pedidoCompra',
        data,
        fields: {
          '(SELECT orcItem_desc FROM orcItem WHERE orcItem.orcItem_id = pedidoCompra.orcItem_id LIMIT 1)': 'orcItem_desc',
          '(SELECT pf_nomeExibicao FROM pf WHERE pedidoCompra.pf_id = pf.pf_id LIMIT 1)': 'pf_nomeExibicao',
          '(SELECT pedidoCompraStatus_nome FROM pedidoCompraStatus WHERE pedidoCompra.pedidoCompraStatus_id = pedidoCompraStatus.pedidoCompraStatus_id LIMIT 1)': 'pedidoCompraStatus_nome',
          '(SELECT COUNT(*) FROM compraCotacao WHERE compraCotacao.pedidoCompra_id = pedidoCompra.pedidoCompra_id)': 'compraCotacao_count',
          '(SELECT categGr_id FROM categ WHERE categ.categ_id = (SELECT categ_id FROM orcItem WHERE orcItem.orcItem_id = pedidoCompra.orcItem_id LIMIT 1) LIMIT 1)': 'categGr_id',
          pedidoCompra_comContrato: 'pedidoCompra_comContrato',
        },
      });

      const response = await oikosApi.get(`/?${query}`);
      const rows = response.data || [];
      setPedidosDeCompra(
        onlyPedidoCotacao
          ? rows.filter((row) => Number(row.pedidoCompra_pedidoCotacao) === 1)
          : rows,
      );
      console.log('pedidosDeCompra', response.data);
    } catch (error) {
      console.error('Error fetching pedidos de compra:', error);
    } finally {
      setIsLoadingPedidosCompra(false);
    }
  };

  const checkCamposObrigatoriosParcelas = (parcela, counter) => {
    const camposObrigatorios = {
      contrFornEvento_desc: 'Descrição',
      contrFornEvento_num: 'Nº contrato',
      contrFornEvento_pgtoPrazoDias: 'Prazo',
      contrFornEvento_dtPrev: 'Data',
    }

    for (const campo of Object.keys(camposObrigatorios)) {
      if (!parcela[campo]) {
        notifyError(`O campo "${camposObrigatorios[campo]}" da parcela ${counter} é obrigatório.`)
        return false
      }
    }
    return true
  }

  function checkCamposObrigatoriosContrForn() {
    const camposObrigatorios = {
      contrForn_desc: 'Descrição',
      contrForn_parteTab: 'Tipo de contratado',
      contrForn_parteId: 'Contratado',
      contrForn_obj: 'Objeto',
      contrForn_vlrGlobal: 'Valor global',
      contrForn_dtVigIni: 'Data de início da vigência',
      contrForn_dtVigFim: 'Data de fim da vigência',
      contrFornTp_id: 'Tipo de contrato',
      contrForn_detalhamento: 'Detalhamento',
    }

    for (const campo of Object.keys(camposObrigatorios)) {
      if (!contrFornData[campo]) {
        notifyError(`O campo "${camposObrigatorios[campo]}" do contrato é obrigatório.`)
        return false
      }
    }
    return true
  }

  const handleDetailChange = (rowIndex, field, value) => {
    setListaParcelas(old =>
      old.map((item, idx) =>
        idx === rowIndex ? { ...item, [field]: value } : item
      )
    );
  };

  const fetchOrcItemsForSelect = async (centro_id) => {
    try {
      let dataOrcItems = {
        orcItem_ativo: 1,
        nivel2_id: centro_id,
      }

      const queryString = `/?${qs.stringify({
        action: 'get',
        table: 'viewRubr_OrcItem',
        fields: {
          orcItem_id: 'value',
          item_orcamentario: 'label',
          nivel2_id: 'cc_id',
          nivel2: 'cc_nome',
          "(SELECT categGr_id FROM categ WHERE categ.categ_id = viewRubr_OrcItem.categ_id LIMIT 1)" : "categGr_id",
          "(SELECT pf_id FROM orcItem WHERE orcItem.orcItem_id = viewRubr_OrcItem.orcItem_id LIMIT 1)" : "pf_id",
          "(SELECT contratoForn_id FROM orcItem WHERE orcItem.orcItem_id = viewRubr_OrcItem.orcItem_id LIMIT 1)" : "contratoForn_id",
          "(SELECT projAtuacao_id FROM projAtuacao WHERE projAtuacao.projAtuacao_id = (SELECT projAtuacao_id FROM propOrcItem WHERE propOrcItem.propOrcItem_id = (SELECT propOrcItem_id FROM orcItem WHERE orcItem.orcItem_id = viewRubr_OrcItem.orcItem_id LIMIT 1) LIMIT 1) LIMIT 1)" : "projAtuacao_id"
        },
        data: dataOrcItems,
        order: 'label'
      })}`;

      const resp = await oikosApi.get(queryString);
      console.log('resp', resp.data);

      setSelOrcItems(resp.data);
    } catch (error) {
      console.error("Error fetching orcItems:", error);
      return [];
    }
  }

  const fetchFornecedoresForSelect = async (table) => {
    try {
      let resp = {data: []};
      if (table === 'pf') {
        const queryString = `/?${qs.stringify({
          action: 'get',
          table: 'pf',
          fields: {
            pf_id: 'value',
            pf_nomeExibicao: 'label'
          },
          data: {pf_fornecedor: 1, pf_ativo: 1},
          order: 'label'
        })}`;

        resp = await oikosApi.get(queryString);
      } else if (table === 'pj') {
        const queryString = `/?${qs.stringify({
          action: 'get',
          table: 'pj',
          fields: {
            pj_id: 'value',
            pj_nomefanta: 'label'
          },
          data: {pj_fornecedor: 1, pj_ativo: 1},
          order: 'label'
        })}`;

        resp = await oikosApi.get(queryString);
      }
      console.log("Fornecedores fetched:", resp.data);

      setSelFornecedores(resp.data);
    } catch (error) {
      console.error("Error fetching orcItems:", error);
      return [];
    }
  }

  const fetchCentroDeCustoForSelect = async () => {
    try {
      let dataOrcRubr = {
        orcRubr_ativo: 1,
        orcRubr_mae: `!IN!(1, 2)`
      }

      const resTodosCentrosDeCustos = await selectValues('orcRubr', 'orcRubr_id', 'orcRubr_nome', dataOrcRubr);

      const sortedCentrosDeCustos = (resTodosCentrosDeCustos).sort((a, b) => {
        if (a.label < b.label) return -1;
        if (a.label > b.label) return 1;
        return 0;
      });

      setSelCentroDeCusto(sortedCentrosDeCustos);
    } catch (error) {
      console.error("Error fetching orcItems:", error);
      return [];
    }
  }

  const getPossiveisFornecedores = async (pfTrue) => {
    try {
      if (!pfTrue) {
        const res = await selectValues('pj', 'pj_id', 'pj_nomefanta');

        const sortedFavs = (res).sort((a, b) => {
          if (a.label < b.label) return -1;
          if (a.label > b.label) return 1;
          return 0;
        })

        setSelPjs(sortedFavs);

        return sortedFavs;

      } else {
        const res = await selectValues('pf', 'pf_id', 'pf_nomeExibicao');

        const sortedFavs = (res).sort((a, b) => {
          if (a.label < b.label) return -1;
          if (a.label > b.label) return 1;
          return 0;
        })

        setSelPfs(sortedFavs);

        return sortedFavs;

      }
    } catch (error) {
      console.error("Failed to fetch product details:", error);
    }
  };

  const fetchPfsForSelect = async () => {
    const res = await selectValues('pf', 'pf_id', 'pf_nomeExibicao', {pf_ativo: 1});
    const sortedFornecedores = (res).sort((a, b) => {
      if (a.label < b.label) return -1;
      if (a.label > b.label) return 1;
      return 0;
    })

    setSelPfs(sortedFornecedores);
  }

  const fetchPropItemsForSelect = async () => {
    const res = await oikosApi.get(
      `/?${qs.stringify({
        action: "get",
        table: "propItem",
        data: {
          propItem_ativo: 1,
        },
        fields: {
          "(SELECT propItem_id FROM propItem AS pi WHERE propItem.propItem_id = pi.propItem_id )": "value",
          "(SELECT CONCAT(propItemGr_label, '/', categ_label, '/', propItem_desc, '/', unidade_label) AS label FROM propItem AS pi WHERE propItem.propItem_id = pi.propItem_id )": 'label',
        },
      })}`
    );
    const sortedPropItems = (res.data).sort((a, b) => {
      if (a.label < b.label) return -1;
      if (a.label > b.label) return 1;
      return 0;
    })

    setSelPropItems(sortedPropItems);
  }

  const fetchStatusForSelect = async () => {
    try {
      setSelStatus(await selectValues('contrFornStatus', 'contrFornStatus_id', 'contrFornStatus_nome'));
    } catch (error) {
      console.error("Error fetching Status:", error);
      return [];
    }
  }

  const fetchTiposDeContratoForSelect = async () => {
    try {
      setSelTipoContrato(await selectValues('contrFornTp', 'contrFornTp_id', 'contrFornTp_nome'));
    } catch (error) {
      console.error("Error fetching Tipos:", error);
      return [];
    }
  }

  const fetchPfsFornecedoresForSelect = async () => {
    try {
      const res = await selectValues('pf', 'pf_id', 'pf_nomeExibicao', {pf_fornecedor: 1, pf_ativo: 1});
      const sortedFavs = (res).sort((a, b) => {
        if (a.label < b.label) return -1;
        if (a.label > b.label) return 1;
        return 0;
      })

      setSelPfsFornecedor(sortedFavs);
    } catch (error) {
      console.error("Error fetching Pfs:", error);
      return [];
    }
  }

  const fetchTiposDeMinutaForSelect = async () => {
    try {
      const selectOptions = await selectValues('tpMinuta', 'tpMinuta_id', 'tpMinuta_nome')
      setSelTiposDeMinuta(selectOptions);
      console.log("Tipos de Minuta fetched:", selectOptions);
    } catch (error) {
      console.error("Error fetching Status:", error);
      return [];
    }
  }

  const fetchPjsFornecedoresForSelect = async () => {
    try {
      const res = await selectValues('pj', 'pj_id', 'pj_razaosocial', {pj_fornecedor: 1, pj_ativo: 1});
      const sortedFavs = (res).sort((a, b) => {
          if (a.label < b.label) return -1;
          if (a.label > b.label) return 1;
          return 0;
        })

        setSelPjsFornecedor(sortedFavs);
    } catch (error) {
      console.error("Error fetching Pjs:", error);
      return [];
    }
  }

  function handleNextPage(page) {
    console.log(page);
    if (page >= 2) return;
    return setPageContrFornForm(page + 1);
  }

  function handlePrevPage(page) {
    console.log(page);
    if (page <= 1) return;
    return setPageContrFornForm(page - 1);
  }

  React.useEffect(() => {
    if (props.isActive === false) return

    Promise.all([
      fetchPfsFornecedoresForSelect(),
      fetchPjsFornecedoresForSelect(),
      fetchStatusForSelect(),
      fetchPfsForSelect(),
      fetchTiposDeContratoForSelect(),
      fetchPedidosDeCompra(),
      fetchCentroDeCustoForSelect(),
      fetchFornecedoresForSelect(),
      fetchTiposDeMinutaForSelect(),
      fetchPropItemsForSelect(),
    ]).catch((error) => {
      console.error('Error preloading pedidos de compra tab:', error)
    })
  }, [props.isActive, onlyPedidoCotacao, props.proj_orcRubrId])

  React.useEffect(() => {
    if (!contrFornData.centroDeCustoRubr_id) return; // Prevent running without centroDeCustoRubr_id
    if(contrFornData.centroDeCustoRubr_id) {
      fetchOrcItemsForSelect(contrFornData.centroDeCustoRubr_id);
    }
  }, [contrFornData.centroDeCustoRubr_id]);

  const createLinkedTasks = async ({ taskTabRef, taskTabId, taskDesc, taskOrientacao, orcItemId, taskTp_id, pfId }) => {
    const normalizedTaskTabId = Number(taskTabId) || 0;
    if (!taskTabRef || !normalizedTaskTabId || !user) return;

    const selectedOrcItem = selOrcItems.find((item) => Number(item.value) === Number(orcItemId));
    const centroDeCusto = Number(selectedOrcItem?.cc_id || selectedOrcItem?.nivel2_id);

    const postBodyTask = {
      action: 'insert',
      table: 'task',
      data: {
        task_tabRef: taskTabRef,
        task_tabId: normalizedTaskTabId,
        pf_id: user.pf_id || undefined,
        task_prazo: moment().add(3, 'days').format('YYYY-MM-DD') || undefined,
        taskTp_id: taskTp_id,
        dpto_id: undefined,
        task_desc: taskDesc,
        task_orientacao: taskOrientacao,
      },
    };

    const responseTask = await oikosApi.post('/', postBodyTask);
    const taskMaeId = responseTask?.data?.[0]?.task_id;

    if (!taskMaeId) return;

    const normalizedPfId = Number(pfId) || 0;
    const pfDestino = normalizedPfId > 0
      ? normalizedPfId
      : ([13, 14].includes(centroDeCusto) ? 2 : 1);

    await oikosApi.post('/', {
      ...postBodyTask,
      data: {
        ...postBodyTask.data,
        pf_id: pfDestino,
        task_mae: taskMaeId,
      },
    });
  };

  async function handleSubmitContrForn() {
    setLoading(true);

    const verificaCamposObrigatoriosContrForn = checkCamposObrigatoriosContrForn();
    if (!verificaCamposObrigatoriosContrForn) return setLoading(false);

    const verificaListaEventos = listaParcelas.length > 0;
    if (!verificaListaEventos) {
      notifyError('É necessário cadastrar pelo menos uma parcela.');
      return setLoading(false);
    }

    const checkValorGlobal = verificarValorGlobal();
    if (!checkValorGlobal) return setLoading(false);

    const checkDocumento = verificaDocumentoContrForn();
    if (!checkDocumento) return setLoading(false);

    const checkValorParcelas = comparaValorGlobalComParcelas();
    if (!checkValorParcelas) return setLoading(false);

    for (let index = 0; index < listaParcelas.length; index++) {
      const parcela = listaParcelas[index];
      const check = checkCamposObrigatoriosParcelas(parcela, (index + 1))
      if (!check) {
        setLoading(false);
        return
      };
    }

    const checkDataVigencia = verificaDataVigencia();
    if (!checkDataVigencia) return setLoading(false);

    const isSaldoValido = verificarSaldoMensalValido(filteredValoresLimites, listaParcelas);
    if (!isSaldoValido) {
      notifyError("Há pelo menos um mês com gasto superior ao valor limite!");
      return setLoading(false);
    }

    const postBodyPedidoCompra = {
      action: 'insert',
      table: 'pedidoCompra',
      data: {
        compraStatus_id: 2,
        orcItem_id: contrFornData.orcItem_id,
        pf_id: user.pf_id,
        pedidoCompra_desc: contrFornData.contrForn_desc,
        pedidoCompra_vlrLimite: contrFornData.contrForn_vlrGlobal,
        pedidoCompra_obs: contrFornData.contrForn_obs,
        pedidoCompra_dtSolicitacao: moment().format('YYYY-MM-DD'),
      }
    };
    const responsePedidoCompra = await oikosApi.post(`/`, postBodyPedidoCompra);
    console.log(responsePedidoCompra);

    const postBodyCompraCotacao = {
      action: 'insert',
      table: 'compraCotacao',
      data: {
        pedidoCompra_id: responsePedidoCompra.data[0].pedidoCompra_id,
        compraCotacao_vlr: contrFornData.contrForn_vlrGlobal,
        compraCotacao_parteTab: contrFornData.contrForn_parteTab,
        compraCotacao_parteId: contrFornData.contrForn_parteId,
        compraCotacao_desc: contrFornData.contrForn_desc,
        compraCotacao_dtCotacao: moment().format('YYYY-MM-DD'),
        compraCotacao_obs: contrFornData.contrForn_obs,
      }
    };
    const responseCompraCotacao = await oikosApi.post(`/`, postBodyCompraCotacao);
    console.log(responseCompraCotacao);

    const numeroContrato = `${responsePedidoCompra.data[0].pedidoCompra_id}.${responseCompraCotacao.data[0].compraCotacao_id}/${new Date().getFullYear()}`;

    const vlrGlobal = Number(contrFornData.contrForn_vlrGlobal) || 0;
    const requiresApproval = needsContrFornApproval(vlrGlobal);
    const contrFornStatusId = requiresApproval
      ? CONTR_FORN_STATUS_EM_APROVACAO
      : CONTR_FORN_STATUS_EM_ASSINATURA;

    try {
      const postBody = {
        action: 'insert',
        table: 'contrForn',
        data: {
          orcItem_id: contrFornData.orcItem_id || undefined,
          contrForn_desc: contrFornData.contrForn_desc || undefined,
          contrForn_num: numeroContrato,
          contrForn_detalhamento: contrFornData.contrForn_detalhamento || undefined,
          contrForn_obj: contrFornData.contrForn_obj || undefined,
          contrForn_parteTab: contrFornData.contrForn_parteTab || undefined,
          contrForn_parteId: contrFornData.contrForn_parteId || undefined,
          contrForn_dtAssin: contrFornData.contrForn_dtAssin || undefined,
          contrForn_dtVigIni: contrFornData.contrForn_dtVigIni || undefined,
          contrForn_dtVigFim: contrFornData.contrForn_dtVigFim || undefined,
          contrForn_dtRescisao: contrFornData.contrForn_dtRescisao || undefined,
          contrFornTp_id: contrFornData.contrFornTp_id || undefined,
          contrForn_vlrGlobal: contrFornData.contrForn_vlrGlobal || undefined,
          contrForn_obs: contrFornData.contrForn_obs || undefined,
          tpMinuta_id: contrFornData.tpMinuta_id || undefined,
          contrFornStatus_id: contrFornStatusId,
          pf_id: user.pf_id
        }
      };
      console.log(postBody)
      let contratadoNome = '';

      const response = await oikosApi.post(`/`, postBody);

      if (contrFornData.contrForn_parteTab === 'pf') {
        contratadoNome = selPfsFornecedor.find(f => f.value === contrFornData.contrForn_parteId).label
      } else if (contrFornData.contrForn_parteTab === 'pj') {
        contratadoNome = selPjsFornecedor.find(f => f.value === contrFornData.contrForn_parteId).label
      }

      {/*
        const query = qs.stringify({
          action: 'get',
          table: 'setor',
          data: { orcRubr_id: contrFornData.centroDeCustoRubr_id },
        });

        const setores = await oikosApi.get(`/?${query}`);
        console.log('setores', setores);
        const dpto_id = setores.data[0]?.dpto_id;
        */}

        try {
          Promise.all((listaParcelas.map(async (parcela, index) => {
            const parcelaBody = {
              action: 'insert',
              table: 'contrFornEvento',
              data: {
                contrForn_id: response.data[0].contrForn_id || undefined,
                contrFornEvento_num: parcela.contrFornEvento_num || undefined,
                contrFornEvento_desc: parcela.contrFornEvento_desc || undefined,
                contrFornEvento_pgtoPrazoDias: persistPgtoPrazoDias(parcela.contrFornEvento_pgtoPrazoDias),
                contrFornEvento_dtPrev: parcela.contrFornEvento_dtPrev ? moment(parcela.contrFornEvento_dtPrev).format('YYYY-MM-DD') : undefined,
                contrFornEvento_dtReal: parcela.contrFornEvento_dtReal ? moment(parcela.contrFornEvento_dtReal).format('YYYY-MM-DD') : undefined,
                contrFornEvento_aprovNecessita: 1,
                contrFornEvento_aprovLiberado: parcela.contrFornEvento_aprovLiberado ? 1 : 0,
                contrFornEvento_obs: parcela.contrFornEvento_obs || undefined,
                contrFornEvento_usuarioCria: user.pf_id,
                contrFornEvento_usuarioMod: user.pf_id,
                categ_id: parcela.categ_id || undefined,
                contrFornEvento_vlr: parcela.contrFornEvento_vlr || 0,
              },
            }
            console.tron.log('parcelaBody', parcelaBody)
            const parcelaCreated = await oikosApi.post('/', parcelaBody)
            console.tron.log('parcelaCreated', parcelaCreated)
          })))
        } catch (error) {
          console.error(error)
        }
      await saveDocuments(filesContrForn, response.data[0])

      if (requiresApproval) {
        const postBodyTask = {
          action: 'insert',
          table: 'task',
          data: {
            task_tabRef: 'contrForn',
            task_tabId: response.data[0].contrForn_id,
            pf_id: user.pf_id,
            task_prazo: moment().add(3, 'days').format('YYYY-MM-DD') || undefined,
            taskTp_id: 3,
            dpto_id: undefined,
            task_desc: `Aprovar contrato ${response.data[0].contrForn_num} ${contratadoNome}`,
            task_orientacao: 'Avalie o anexo desta tarefa. Após, clique em "Aprovar" ou "Rejeitar" de acordo com o seu julgamento',
            task_usuarioCria: user.pf_id,
            task_usuarioMod: user.pf_id,
          }
        };

        const responseTask = await oikosApi.post(`/`, postBodyTask);

        const centroDeCusto = Number(selOrcItems.filter(oi => oi.value === contrFornData.orcItem_id)[0]?.nivel2_id);

        if (selOrcItems.length > 0 && [13, 14].includes(centroDeCusto)) {
          await oikosApi.post(`/`, {...postBodyTask, data: { ...postBodyTask.data, pf_id: 2, task_mae: responseTask.data[0].task_id}});
        } else if (selOrcItems.length > 0 && !([13, 14].includes(centroDeCusto))) {
          await oikosApi.post(`/`, {...postBodyTask, data: { ...postBodyTask.data, pf_id: 1, task_mae: responseTask.data[0].task_id}});
        }
      }

      //setIsModalProdutosOpen(false);
      handleCloseModal();
      fetchPedidosDeCompra(); // Refresh the list after creation
    } catch (error) {
      console.error("Error creating cotação:", error);
    } finally {
      setLoading(false);
    }
  }

  const handleOpenViewPedidoCompraModal = async (pedidoCompra) => {
    setViewPedidoCompraRow(pedidoCompra);
    setViewPedidoCompraModalIsOpen(true);
  };

  const handleOpenViewCompraCotacaoModal = (compraCotacao, pedidoCompra) => {
    const compraCotacaoId = Number(compraCotacao?.compraCotacao_id) || 0;
    if (!compraCotacaoId) return;

    setViewCompraCotacaoRow({
      ...compraCotacao,
      pedidoCompra_id: compraCotacao.pedidoCompra_id || pedidoCompra?.pedidoCompra_id,
    });
    setViewCompraCotacaoModalIsOpen(true);
  };

  const handleOpenEditPedidoCompraModal = (listagemRow) => {
    const pedidoCompraId = Number(listagemRow?.pedidoCompra_id) || 0
    if (!pedidoCompraId) return

    setCotacaoPedidoExistenteRow(null)
    setEditPedidoCompraRow(listagemRow)
    setPedidoCompraModalOpen(true)
  };

  const handleOpenCotacaoParaPedidoExistente = (pedidoCompra) => {
    const pedidoCompraId = Number(pedidoCompra?.pedidoCompra_id) || 0
    if (!pedidoCompraId) return

    setEditPedidoCompraRow(null)
    setCotacaoPedidoExistenteRow(pedidoCompra)
    setPedidoCompraModalOpen(true)
  };

  const handleCotacaoPedidoCompraSuccess = async () => {
    await fetchPedidosDeCompra()
    setCompraCotacoesRefreshKey((prev) => prev + 1)
  };

  const pedidoCompraModalOrcItems = React.useMemo(() => {
    const baseItems = Array.isArray(selOrcItems) ? selOrcItems : [];
    const extraItems = [editPedidoCompraRow, viewPedidoCompraRow]
      .filter((pedidoCompra) => pedidoCompra?.orcItem_id && pedidoCompra?.orcItem_desc)
      .map((pedidoCompra) => ({
        value: pedidoCompra.orcItem_id,
        label: pedidoCompra.orcItem_desc,
        nivel2_id: pedidoCompra.centroDeCustoRubr_id,
        projAtuacao_id: pedidoCompra.projAtuacao_id,
        categGr_id: pedidoCompra.categGr_id,
      }));

    return [...baseItems, ...extraItems].filter((item, index, items) => (
      items.findIndex((candidate) => Number(candidate.value) === Number(item.value)) === index
    ));
  }, [selOrcItems, editPedidoCompraRow, viewPedidoCompraRow]);

  const pedidosFiltrados = React.useMemo(() => {
    if (onlyPedidoCotacao) {
      return pedidosDeCompra;
    }
    const statusId = cotacaoStatusTab === 0
      ? PEDIDO_COMPRA_STATUS_APROVADO
      : PEDIDO_COMPRA_STATUS_CONTRATADO;
    return pedidosDeCompra.filter(
      (row) => Number(row.pedidoCompraStatus_id) === statusId,
    );
  }, [pedidosDeCompra, onlyPedidoCotacao, cotacaoStatusTab]);

  const renderPedidosListTable = () => (
    <PedidosCompraListTable
      pedidosCompra={pedidosFiltrados}
      showEquipePedidoCompraFields={false}
      showOrcItemDesc={!onlyPedidoCotacao}
      showVlrLimite={!onlyPedidoCotacao}
      fetchPedidoCompraDocuments={fetchPedidoCompraDocuments}
      isLoading={isLoadingPedidosCompra}
      loadingLabel={onlyPedidoCotacao ? 'Carregando cotações...' : 'Carregando pedidos de compra...'}
      onViewPedidoCompra={handleOpenViewPedidoCompraModal}
      onEditPedidoCompra={onlyPedidoCotacao ? undefined : handleOpenEditPedidoCompraModal}
      onAbrirCotacaoPedidoCompra={handleOpenCotacaoParaPedidoExistente}
      onViewCompraCotacao={handleOpenViewCompraCotacaoModal}
      compraCotacoesRefreshKey={compraCotacoesRefreshKey}
      onPedidoCompraOrcItemLinked={async (updatedPedidoCompra) => {
        setPedidosDeCompra((prev) => prev.map((pedido) => (
          Number(pedido.pedidoCompra_id) === Number(updatedPedidoCompra.pedidoCompra_id)
            ? { ...pedido, ...updatedPedidoCompra }
            : pedido
        )))
      }}
      onPedidoCompraContratado={fetchPedidosDeCompra}
      onOpenContrForn={props.onOpenContrForn}
    />
  );

  const handleOpenNovoPedidoOuCotacao = (tipo) => {
    setEditPedidoCompraRow(null);
    setCotacaoPedidoExistenteRow(null);
    setTipoContratacaoModal(tipo);
    setAbrirCotacaoDropdownOpen(false);
    setPedidoCompraModalOpen(true);
  };

  const openPedidoButtonLabel = 'Abrir cotação';

  const openPedidoButton = (
    <ButtonDropdown
      isOpen={abrirCotacaoDropdownOpen}
      toggle={() => setAbrirCotacaoDropdownOpen((prev) => !prev)}
    >
      <DropdownToggle caret>
        {openPedidoButtonLabel}
      </DropdownToggle>
      <DropdownMenu right>
        <DropdownItem onClick={() => handleOpenNovoPedidoOuCotacao(TIPO_CONTRATACAO.PADRAO)}>
          {TIPO_CONTRATACAO_LABEL[TIPO_CONTRATACAO.PADRAO]}
        </DropdownItem>
        <DropdownItem onClick={() => handleOpenNovoPedidoOuCotacao(TIPO_CONTRATACAO.RAPIDA)}>
          {TIPO_CONTRATACAO_LABEL[TIPO_CONTRATACAO.RAPIDA]}
        </DropdownItem>
        <DropdownItem onClick={() => handleOpenNovoPedidoOuCotacao(TIPO_CONTRATACAO.ADESAO)}>
          {TIPO_CONTRATACAO_LABEL[TIPO_CONTRATACAO.ADESAO]}
        </DropdownItem>
      </DropdownMenu>
    </ButtonDropdown>
  );

  return (
    <>
      <Container fluid>
        {onlyPedidoCotacao ? (
          <>
            <div className="d-flex justify-content-end align-items-center mb-2">
              {openPedidoButton}
            </div>
            {renderPedidosListTable()}
          </>
        ) : (
          <Tabs selectedIndex={cotacaoStatusTab} onSelect={setCotacaoStatusTab}>
            <TabList>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <Tab>Em seleção</Tab>
                  <Tab>Contratados</Tab>
                </div>
                {openPedidoButton}
              </div>
            </TabList>
            <TabPanel>
              {renderPedidosListTable()}
            </TabPanel>
            <TabPanel>
              {renderPedidosListTable()}
            </TabPanel>
          </Tabs>
        )}
        {onlyPedidoCotacao || (!editPedidoCompraRow && !cotacaoPedidoExistenteRow) ? (
          <ModalPedidoCotacao
            isOpen={isPedidoCompraModalOpen}
            onClose={handleCloseModal}
            onSuccess={fetchPedidosDeCompra}
            user={user}
            isPedidoCompra={!onlyPedidoCotacao}
            selCentroDeCusto={selCentroDeCusto}
            initialTipoContratacao={tipoContratacaoModal}
            lockTipoContratacao
            title={`${openPedidoButtonLabel} — ${TIPO_CONTRATACAO_LABEL[tipoContratacaoModal] || ''}`.trim()}
            submitLabel={openPedidoButtonLabel}
          />
        ) : (
        <ModalPedidoCompra
          isOpen={isPedidoCompraModalOpen}
          onClose={handleCloseModal}
          selCentroDeCusto={selCentroDeCusto}
          selOrcItems={pedidoCompraModalOrcItems}
          selPropItems={selPropItems}
          editPedidoCompraRow={cotacaoPedidoExistenteRow || editPedidoCompraRow}
          onSuccess={
            cotacaoPedidoExistenteRow
              ? handleCotacaoPedidoCompraSuccess
              : fetchPedidosDeCompra
          }
          user={user}
          createLinkedTasks={createLinkedTasks}
          onEquipeSuccess={async (payload) => {
            if (payload?.orcItem_id && payload?.contratoForn_id) {
              setSelOrcItems((prev) => prev.map((item) => (
                Number(item.value) === Number(payload.orcItem_id)
                  ? { ...item, contratoForn_id: payload.contratoForn_id }
                  : item
              )));
            }
          }}
          onSkipCotacao={() => {
            setPedidoCompraModalOpen(false);
            setContrFornData({});
            setSelOrcItems([]);
            setListaDotacoes([]);
            setValoresLimites([]);
            setIsModalProdutosOpen(true);
          }}
          hidePropItem
          hideQuantidadeOportunidades
          hideDtLimite
          showSkipCotacao={false}
          allowPedidoSemOrcItem={!cotacaoPedidoExistenteRow}
          modoCotacao={Boolean(cotacaoPedidoExistenteRow)}
          cotacaoParaPedidoExistente={Boolean(cotacaoPedidoExistenteRow)}
          pedidoCompraPedidoCotacao={0}
          title={
            cotacaoPedidoExistenteRow
              ? 'Adicionar proposta'
              : 'Abrir pedido de compra'
          }
          submitLabel={
            cotacaoPedidoExistenteRow
              ? 'Adicionar proposta'
              : 'Adicionar pedido de compra'
          }
        />
        )}
        {onlyPedidoCotacao ? null : (
        <ModalPedidoCompra
          isOpen={viewPedidoCompraModalIsOpen}
          onClose={() => {
            setViewPedidoCompraModalIsOpen(false);
            setViewPedidoCompraRow(null);
          }}
          selCentroDeCusto={selCentroDeCusto}
          selOrcItems={pedidoCompraModalOrcItems}
          selPropItems={selPropItems}
          editPedidoCompraRow={viewPedidoCompraRow}
          showSkipCotacao={false}
          hidePropItem
          hideQuantidadeOportunidades
          hideDtLimite
          readOnly
          title="Visualizar pedido de compra"
        />
        )}
        {onlyPedidoCotacao ? (
          <ModalPedidoCotacao
            isOpen={viewPedidoCompraModalIsOpen}
            onClose={() => {
              setViewPedidoCompraModalIsOpen(false);
              setViewPedidoCompraRow(null);
            }}
            editPedidoCompraRow={viewPedidoCompraRow}
            readOnly
            title="Visualizar cotação"
          />
        ) : null}
        <ModalPedidoCompra
          isOpen={viewCompraCotacaoModalIsOpen}
          onClose={() => {
            setViewCompraCotacaoModalIsOpen(false);
            setViewCompraCotacaoRow(null);
          }}
          editCompraCotacaoRow={viewCompraCotacaoRow}
          showSkipCotacao={false}
          hidePropItem
          hideQuantidadeOportunidades
          hideDtLimite
          readOnly
          modoCotacao
          title="Visualizar cotação"
        />
      </Container>
    </>
  )
}

export default CotacoesTab
